import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { Redirect }from 'react-router-dom'

// Components
import Header from '../../components/Global/Header'
import FormContainer from '../../components/Global/FormContainer'

// Forms
import SignUpDefault from './Forms/SignUpDefault'
import CompleteFacebookSignUpForm from './Forms/CompleteFacebookSignUpForm'
import CompleteTwitterSignUpForm from './Forms/CompleteTwitterSignUpForm'
import ConnectProfile from './Forms/ConnectProfile'
import AthleteInfo from "./Forms/AthleteInfo"
import SportSelection from "./Forms/SportSelection"
import PlanSelection from "./Forms/PlanSelection"
import SignupPayment from "./Forms/SignupPayment"
import AcceptInvitationSignUpForm from "./Forms/AcceptInvitationSignUpForm"

// Screens
import OnboardingSuccess from './OnboardingSuccess'

// Actions
import { showModal } from '../../actions/modal'
import { updateUserState } from '../../actions/user'
import { updateForm } from '../../actions/onboarding'
import { setActiveProfile } from '../../actions/activeProfile'
import { getProfileAccountDetails } from '../../actions/accountDetails'

class SignUp extends Component {
  state = {
    userInfo: {},
    athleteInfo: {},
    sportInfo: {},
    form: ''
  }

  componentWillMount() {
    this.handleFormLoad(this.props)
  }

  componentDidMount() {
    this.handleFormLoad(this.props)
  }

  componentWillReceiveProps(nextProps) {
    this.handleFormLoad(nextProps)
  }

  handleFormLoad(props) {
    const { form } = props.match.params
    const { currentForm, prevForm } = props.onboarding

    if (form === 'maintainer-invitation') {
      this.setActiveForm(form, 'sign-up')
      return
    }

    if (
      (form === 'complete-facebook-sign-up' ||form === 'complete-twitter-sign-up')
      && prevForm !== 'sign-up'
    ) {
      this.props.updateOnboardingForm({
        prevForm: 'sign-up',
        currentForm: form
      })
      this.setActiveForm(form, 'sign-up')
    } else if (currentForm && prevForm) {
      this.setActiveForm(currentForm, prevForm)
    } else {
      this.setActiveForm('sign-up', '')
    }
  }

  setActiveForm = (currentForm, prevForm) => {
    const { form } = this.props.match.params

    this.setState((state) => ({
      ...state,
      form: prevForm ? currentForm : 'sign-up'
    }))

    if (
      currentForm
      && (form !== currentForm)
    ) {
      this.props.history.push(`/sign-up/${currentForm}`)
    }
  }

  handleFormChange = (currentForm, prevForm) => {
    this.props.updateOnboardingForm({
      prevForm,
      currentForm
    })
  }

  handleSubmit = (postSubmitDestination) => {
    let modal = {
      modalType: this.props.user.paid_content ? 'onboarding-success' : 'onboarding-success-trial'
    }

    this.initializeReduxData()
    this.props.showModal(modal)
    this.props.history.push(postSubmitDestination)
  }

  initializeReduxData() {
    this.addMaintainedProfileToReduxUser()
    this.setReduxActiveProfileAndDetails()
    this.markReduxLoginComplete()
  }

  addMaintainedProfileToReduxUser() {
    const { onboarding } = this.props
    let updatedUser = {...this.props.user}

    updatedUser.maintained_profiles.push(onboarding.maintained_profile)

    this.props.updateReduxUser(updatedUser)
  }

  setReduxActiveProfileAndDetails() {
    const { user } = this.props
    const username = this.props.onboarding.maintained_profile.username

    this.props.setActiveProfile(username)
    this.props.setReduxAccountDetails(user, username)
  }

  markReduxLoginComplete() {
    let updatedUser = {...this.props.user}

    updatedUser.reduxLogInComplete = true
    updatedUser.isOnboarding = false

    this.props.updateReduxUser(updatedUser)
  }

  renderFormSlide() {
    const { form } = this.state
    const { appName, activeProfile } = this.props
    const {
      isLoggedIn,
      role,
      maintained_profiles,
      requested_profiles,
      reduxLogInComplete
    } = this.props.user

    if (form === 'maintainer-invitation') {
      return (<AcceptInvitationSignUpForm
        appName={appName}
        handleFormSubmit={this.handleSubmit}
        token={this.props.match.params.token}
      />)
    }
    else if (
        isLoggedIn &&
        reduxLogInComplete &&
        (maintained_profiles.length > 0 || requested_profiles.length > 0) &&
        activeProfile.participations.length > 0
    ) {
      return ( <Redirect to={{ pathname: '/' }}/> )
    }
    else if (isLoggedIn) {
      switch (form) {
        case 'sign-up':
          return (
            <SignUpDefault
              appName={appName}
              handleFormChange={this.handleFormChange}
            />
          )
          // eslint-disable-next-line no-unreachable
          break
        case 'invitation':
          return ( <SignUpDefault appName={appName} invitation={true} handleFormChange={this.handleFormChange} /> )
          // eslint-disable-next-line no-unreachable
          break
        case 'connect-account':
          return ( <ConnectProfile appName={appName} handleFormChange={this.handleFormChange} /> )
          // eslint-disable-next-line no-unreachable
          break
        case 'connect-account-continue':
          return ( <ConnectProfile appName={appName} handleFormChange={this.handleFormChange} viaLogin={true} /> )
          // eslint-disable-next-line no-unreachable
          break
        case 'athlete-info':
          return ( <AthleteInfo appName={appName} handleFormChange={this.handleFormChange} /> )
          // eslint-disable-next-line no-unreachable
          break
        case 'athlete-info-continue':
          return ( <AthleteInfo appName={appName} handleFormChange={this.handleFormChange} viaLogin={true} /> )
          // eslint-disable-next-line no-unreachable
          break
        case 'sport-selection':
          return ( <SportSelection appName={appName} handleFormChange={this.handleFormChange} /> )
          // eslint-disable-next-line no-unreachable
          break
        case 'plan-selection':
          return ( <PlanSelection appName={appName} handleFormChange={this.handleFormChange} handleFormSubmit={this.handleSubmit} /> )
          // eslint-disable-next-line no-unreachable
          break
        case 'sign-up-payment':
          return ( <SignupPayment appName={appName} handleFormChange={this.handleFormChange}  handleFormSubmit={this.handleSubmit} /> )
          // eslint-disable-next-line no-unreachable
          break
        case 'success':
          return (<OnboardingSuccess appName={appName} user={this.props.user} /> )
          // eslint-disable-next-line no-unreachable
          break
        case 'complete-facebook-sign-up':
        case 'complete-twitter-sign-up':
          return role === 'athlete'
          ? ( <Redirect to={{ pathname: '/sign-up/athlete-info' }}/> )
          : ( <Redirect to={{ pathname: '/sign-up/connect-account' }}/> )
          // eslint-disable-next-line no-unreachable
          break
        default:
          return ( <Redirect to={{ pathname: '/sign-up' }}/> )
          // eslint-disable-next-line no-unreachable
          break
      }
    } else {
      switch (form) {
        case 'complete-facebook-sign-up':
          return ( <CompleteFacebookSignUpForm appName={appName} handleFormChange={this.handleFormChange} /> )
          // eslint-disable-next-line no-unreachable
          break
        case 'complete-twitter-sign-up':
          return ( <CompleteTwitterSignUpForm appName={appName} handleFormChange={this.handleFormChange} /> )
          // eslint-disable-next-line no-unreachable
          break
        case 'facebook-denied':
          return ( <SignUpDefault appName={appName} handleFormChange={this.handleFormChange} socialAuthDenied={'facebook'} /> )
          // eslint-disable-next-line no-unreachable
          break
        case 'twitter-denied':
          return ( <SignUpDefault appName={appName} handleFormChange={this.handleFormChange} socialAuthDenied={'twitter'} /> )
          // eslint-disable-next-line no-unreachable
          break
        case 'sign-up':
          return ( <SignUpDefault appName={appName} handleFormChange={this.handleFormChange} /> )
          // eslint-disable-next-line no-unreachable
          break
        default:
          return ( <Redirect to={{ pathname: '/sign-up' }}/> )
          // eslint-disable-next-line no-unreachable
          break
      }
    }
  }

  render() {
    const { path } = this.props

    return (
      <div className="onboarding">
        <Header path={ path }/>
        <FormContainer>
          {this.renderFormSlide()}
        </FormContainer>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    onboarding: state.onboarding,
    user: state.user,
    activeProfile: state.activeProfile,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    showModal: modalType => {
      dispatch(showModal(modalType))
    },
    updateReduxUser: user => {
      dispatch(updateUserState(user))
    },
    setActiveProfile: (username) => dispatch(setActiveProfile(username)),
    setReduxAccountDetails: (user, username) => dispatch(getProfileAccountDetails(user, username)),
    updateOnboardingForm: formData => {
      dispatch(updateForm(formData))
    },
  }
}

// export default connect(state => state)(SignUp)
export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(SignUp))



// WEBPACK FOOTER //
// ./src/screens/Onboarding/SignUp.js